module.exports = __webpack_public_path__ + "static/6M_2022_Financial_Reporting-4e47ea289d0ad673b4bf25d627984a1a.pdf";